import { exists } from '@/api'

export interface AuthorityList {
  authorityNo: string
  display: string
  displayKana: string
}

export function AuthorityListFromJSON(json: any): AuthorityList {
  return {
    authorityNo: exists(json, 'authority_no') ? json.authority_no : '',
    display: exists(json, 'display') ? json.display : '',
    displayKana: exists(json, 'display_kana') ? json.display_kana : ''
  }
}
